import React from 'react'
import { dashboardColors, theme } from '../../../themes/Theme'

const AttendeeOverview = ({
    DETAnalytics
}) => {
    return (
        <>
            <div className='overview-div fontSize label mt-2 p-2 d-flex justify-content-between'>
                <div>
                    <p className='mb-2 mt-2'>
                        <span className='dot-container purple-dot ml-2 mr-2'></span>
                        No of Attendees: {DETAnalytics?.total_attendees ?? 0}
                    </p>
                    <p className='mb-2'>
                        <span className='dot-container red-dot ml-2 mr-2'></span>
                        No of attendees without DET Codes: {DETAnalytics?.attendees_without_det_code ?? 0}
                    </p>
                </div>
                <div className="flex-grow-1 d-flex align-items-center bar-container-div">
                    <div className="bar-container mt-2 w-100">
                        <div className="bar-label text-left">
                            {DETAnalytics?.attendees_without_det_code ?? 0} / {DETAnalytics?.total_attendees ?? 0}
                        </div>
                        <div className="bar" style={{ position: "relative", height: "8px", background: "#ddd" }}>
                            {/* Check if both values are 0 */}
                            {DETAnalytics?.total_attendees === 0 ? (
                                <div
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        background: "#ddd",
                                    }}
                                ></div>
                            ) : (
                                <>
                                    {/* Purple Bar for Total Attendees */}
                                    <div
                                        className="purple-dot"
                                        style={{
                                            width: "100%",
                                            background: "purple",
                                            height: "100%",
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            zIndex: 1,
                                        }}
                                    ></div>
                                    {/* Red Bar for Attendees Without DET Code */}
                                    <div
                                        className="red-dot"
                                        style={{
                                            width: `${(DETAnalytics?.attendees_without_det_code / DETAnalytics?.total_attendees) * 100 ?? 0}%`,
                                            background: "red",
                                            height: "100%",
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            zIndex: 2,
                                        }}
                                    ></div>
                                </>
                            )}
                        </div>
                    </div>

                </div>
            </div>
            <style jsx>{`
                .overview-title{
                    font-family: Hind;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 22.41px;
                    color: #333333;
                }
                .overview-div{
                    border: 1px solid #E2E2E2;
                    background: #F8F8F8;
                    border-radius: 5px;
                }
                .fontSize {
                    font-size: 15px;
                }
                .dot-container{
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                }
                .green-dot{ 
                    background: #03AF30;
                }
                .yellow-dot{
                    background: #EBC80F;
                }
                .purple-dot{
                   background: ${dashboardColors[theme].primary};
                }
                .red-dot{
                    background: #FB5850;
                }
                .bar-container-div{
                    background: #ffffff;
                    padding: 0 20px;
                    margin-left: 50px;
                    border-radius: 6px;
                }
                .bar-container {
                    position: relative;
                    text-align: center;
                }
                .bar-label {
                    font-size: 14px;
                    font-weight: 500;
                    color: #333333;
                    margin-bottom: 5px;
                }
                .bar {
                    display: flex;
                    height: 8px;
                    border-radius: 5px;
                    overflow: hidden;
                    background: #C3CDDF;
                }
            `}</style>
        </>
    )
}

export default AttendeeOverview